import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getOnlineOrder = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.data);
